module.exports = __webpack_public_path__ + "readerCode_02.png?521ddcfc8295735c5c54793e195bb35e";